module.exports = __webpack_public_path__ + "media/images/emblems/GW-SG-Buetschwil-Ganterschwil-e125c7f3409285b2d912be635a59bdaa.png";